import { useFormik } from 'formik';
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Alert,
  Card,
  CardBody,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from 'reactstrap';
import * as Yup from 'yup';
import {
  default as logoDark,
  default as logoLight,
} from '../../assets/images/logo-dark.png';
import StyledButton from '../../components/Common/StyledButton';
import withRouter from '../../components/Common/withRouter';
import { forgotPasswordReq } from '../../service/authService';

const ForgotPassword = (props) => {
  document.title = 'Forgot Password | WILLSMEET';

  const [error, setError] = React.useState(null);
  const [success, setSuccess] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);

  const validation = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email('Please enter a valid email address')
        .required('Email is required'),
    }),
    onSubmit: async (values, { resetForm }) => {
      setIsLoading(true);
      setError(null);
      try {
        const email = values.email.trim();
        const response = await forgotPasswordReq({ email: email });
        if (response.success) {
          setSuccess(true);
          resetForm();
        } else {
          setError(response.message || 'Failed to send reset email');
        }
      } catch (err) {
        setError(
          err.response?.data?.message || 'An error occurred. Please try again.'
        );
      } finally {
        setIsLoading(false);
      }
    },
  });

  return (
    <div className="d-flex justify-content-center align-items-center vh-100">
      <Card className="m-0" style={{ width: 450 }}>
        <CardBody>
          <h3 className="text-center my-3">
            <Link to="/" className="d-block auth-logo">
              <img
                src={logoDark}
                alt=""
                height="30"
                className="auth-logo-dark"
              />
              <img
                src={logoLight}
                alt=""
                height="30"
                className="auth-logo-light"
              />
            </Link>
          </h3>

          <div className="p-3">
            <h4 className="text-muted font-size-18 mb-1 text-center">
              Forgot Password
            </h4>
            {success ? (
              <Alert
                color="success"
                style={{
                  color: '#155724',
                  backgroundColor: '#d4edda',
                  borderColor: '#c3e6cb',
                }}
              >
                Password reset link has been sent to your email.
              </Alert>
            ) : (
              <Form
                className="form-horizontal mt-4"
                onSubmit={validation.handleSubmit}
              >
                {error && <Alert color="danger">{error}</Alert>}
                <div className="mb-3">
                  <Label htmlFor="email">Email</Label>
                  <Input
                    name="email"
                    className="form-control"
                    placeholder="Enter email"
                    type="email"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email}
                    invalid={
                      validation.touched.email && !!validation.errors.email
                    }
                    disabled={isLoading}
                  />
                  {validation.touched.email && validation.errors.email && (
                    <FormFeedback type="invalid">
                      {validation.errors.email}
                    </FormFeedback>
                  )}
                </div>
                <Row className="mb-3 mt-4">
                  <div className="text-end">
                    <StyledButton
                      color="primary"
                      style={{ width: '100%' }}
                      type="submit"
                      disabled={isLoading}
                    >
                      {isLoading ? 'Sending...' : 'Reset Password'}
                    </StyledButton>
                  </div>
                </Row>
              </Form>
            )}
            <div className="text-center mt-3">
              <Link to="/login" className="text-muted">
                <i className="mdi mdi-arrow-left"></i> Back to Login
              </Link>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default withRouter(ForgotPassword);
